import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NgbDatepickerModule } from "@ng-bootstrap/ng-bootstrap";
import { ProfileComponent } from "./profile.component";
import { SharedModule } from "../shared/shared.module";
import { AuthGuard } from "../shared/services/AuthGuard.service";
import { JobsModule } from "../jobs/jobs.module";
import { CareersModule } from "../careers/careers.module";
import { TrainingModule } from "../training/training.module";
import { AssessmentListComponent } from "../shared/components/assessments/assessment-list.component";
import { NotesListComponent } from "../shared/components/notes/notes-list.component";
import { NotAuthorized } from "../shared/notfound.component";

@NgModule({
  imports: [
    SharedModule,
    JobsModule, CareersModule, TrainingModule,
    NgbDatepickerModule,
    RouterModule.forChild([
      { path: "profile/", redirectTo: "profile/about" },
      { path: "profile/error/notauthorized", component: NotAuthorized, data: { title: 'Profile' } },
      { path: "profile/:section", component: ProfileComponent, canActivate: [AuthGuard], data: { title: 'Profile' } },
      { path: "", redirectTo: "profile/", pathMatch: "full" },
      { path: "**", redirectTo: "profile/" }
    ])
  ],
  declarations: [
    ProfileComponent,
    AssessmentListComponent,
    NotesListComponent,
    NotAuthorized
  ],
  exports: [],
  providers: [],
  entryComponents: [],
  bootstrap: []
})
export class ProfileModule { }
